export default __webpack_public_path__ + "static/media/domainImg.817c6042.png";